import apiClient from '../../../../common/services/apiClient';

export const apiCallIds = {
  FETCH_LOAN_PHONE_USAGE: 'FETCH_LOAN_PHONE_USAGE',
  FETCH_LOAN_PHONE_USAGE_DETAILS: 'FETCH_LOAN_PHONE_USAGE_DETAILS',
};

const apiError = status => Object.assign(new Error(`Phone usage request failed: ${status}`), { status });

const failureOf = response => apiError(response.response ? response.response.status : 'network');

const request = (path, apiCallId, isValid) =>
  apiClient.get(path, { apiCallId }).then(response => {
    if (!response.ok) throw failureOf(response);
    if (!isValid(response.data)) throw apiError('invalid');
    return response.data;
  });

const isObject = value => !!value && typeof value === 'object' && !Array.isArray(value);

export const fetchPhoneUsage = loanId =>
  request(
    `/loan/${encodeURIComponent(loanId)}/phone-usage`,
    apiCallIds.FETCH_LOAN_PHONE_USAGE,
    body =>
      isObject(body) &&
      body.loanId === loanId &&
      typeof body.status === 'string' &&
      (body.snapshotId === null || (typeof body.snapshotId === 'string' && isObject(body.sourceDevice)))
  );

export const fetchPhoneUsageDetails = loanId =>
  request(
    `/loan/${encodeURIComponent(loanId)}/phone-usage/details`,
    apiCallIds.FETCH_LOAN_PHONE_USAGE_DETAILS,
    body =>
      isObject(body) &&
      body.loanId === loanId &&
      Array.isArray(body.audit) &&
      (body.snapshot === null || (isObject(body.snapshot) && Array.isArray(body.snapshot.records)))
  );



// WEBPACK FOOTER //
// ./src/features/loan-management/components/phone-usage/phoneUsageApi.js